var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('slider'),_c('div',{staticClass:"app-content"},[_c('search-form',{attrs:{"is-links-mode":false}})],1),_c('subscription-form'),_c('news-carousel'),_c('countries-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }